import { render, staticRenderFns } from "./EngagingMentions.vue?vue&type=template&id=1fc0fb12&scoped=true"
import script from "./EngagingMentions.vue?vue&type=script&lang=js"
export * from "./EngagingMentions.vue?vue&type=script&lang=js"
import style0 from "./EngagingMentions.vue?vue&type=style&index=0&id=1fc0fb12&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0fb12",
  null
  
)

export default component.exports